import { render, staticRenderFns } from "./BaseClientAccountCmsInput.vue?vue&type=template&id=68c23163&scoped=true&"
import script from "./BaseClientAccountCmsInput.vue?vue&type=script&lang=js&"
export * from "./BaseClientAccountCmsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c23163",
  null
  
)

export default component.exports